import { UISetting } from "../UISetting";
export class SuperBannerCMSConfiguration {
    constructor(source) {
        this.Name = source.Name;
        this.DisplayMultipleItems = source.DisplayMultipleItems;
        this.DisplayMobileMode = source.DisplayMobileMode;
        this.UISetting = new UISetting(source.UISetting);
        this.EnableLowOdds = source.EnableLowOdds;
    }
}
//# sourceMappingURL=SuperBannerCMSConfiguration.js.map